var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"treeNode"},[_c('el-tree',{attrs:{"data":_vm.topicTree,"props":_vm.defaultProps1,"accordion":"","render-content":_vm.renderContent},on:{"node-click":_vm.handleNodeClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }